import React from 'react';
import LogoImage from 'clientRequirements/images/icon_NS.png';
import './Logo.css';

export const Logo = () => (
    <div>
        <img src={LogoImage} alt="Notz Stucki" className="logo-icon" />
    </div>
);
